import React, { useState } from 'react';
import { Navbar, Nav, Form, Button, Toast } from 'react-bootstrap';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import { DebounceInput } from 'react-debounce-input';
import { useDispatch } from 'react-redux';
import { setQuery } from '../store/action/index';
import { getSearchResult } from '../store/action/index';

function MyNavbar() {
    const dispatch = useDispatch()
    const history = useHistory()
    const isSearchUrl = useRouteMatch("/search")
    const [text, setText] = useState('')
    const [show, setShow] = useState(false)

    function handleOnChange(event) {
        setText(event.target.value)
        setShow(true)
    }

    function handleOnSubmit(event){
        event.preventDefault()
        if(!isSearchUrl){
            dispatch(setQuery(text))
            history.push('/search') 
        } else {
            dispatch(getSearchResult(text))
        }
    }

    return (
        <>
        <Navbar bg="dark" variant="dark" className="sticky-top">
            <Navbar.Brand>MyMovies</Navbar.Brand>
            <Nav className="mr-auto">
                <Link to="/" className="text-light mr-2">Home</Link>
                <Link to="/favorites" className="text-light mr-2">Favorites</Link>
            </Nav>
            <small>
                <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide size="sm">
                    <Toast.Body>{ text }</Toast.Body>
                </Toast>
            </small>
            <Form inline onSubmit={ handleOnSubmit }>
                <>
                    <DebounceInput
                        minLength={2}
                        placeholder="Input text here..."
                        debounceTimeout={300}
                        onChange={handleOnChange} />
                </>
                <Button variant="outline-info" type="submit" className="ml-2">Search</Button>
            </Form>
        </Navbar>
        </>
    )
}

export default MyNavbar